import { render, staticRenderFns } from "./DxWeatherPrecipitationGrid.vue?vue&type=template&id=6c5cc662&"
import script from "./DxWeatherPrecipitationGrid.vue?vue&type=script&lang=js&"
export * from "./DxWeatherPrecipitationGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports